import React, { useEffect, useState } from 'react';
import { fetchWrapper } from '../../../../../../_helpers';
import { toast } from 'react-toastify';
import ContractorPaymentsList from './ContractorPaymentsList';

function ZealContractorPayroll({ employee, providerPayroll, teamId, checkStatus }) {
    const contractorID = employee?.data?.basic?.contractorID || employee?.metadata?.contractorID;
    const companyID = providerPayroll?.metadata?.companyID || employee?.data?.basic?.companyID;

    const [contractorPayments, setContractorPayments] = useState([]);
    const [isBusy, setIsBusy] = useState(false);

    async function fetchContractorPayments(companyID, contractorID) {
        try {
            setIsBusy(true);
            const params = new URLSearchParams();
            if (checkStatus) params.set('status', checkStatus);
            if (teamId) params.set('team', teamId);
            const queryString = params.toString();
            const response = await fetchWrapper.get(
                `/evv/payroll/zeal/contractor/${companyID}/${contractorID}/payments${queryString ? `?${queryString}` : ''}`
            );
            setContractorPayments(Array.isArray(response) ? response : []);
        } catch (error) {
            if (error?.name === 'AbortError') return;
            toast.error("Couldn't fetch (Contractor) payments");
        } finally {
            setIsBusy(false);
        }
    }

    useEffect(() => {
        if (companyID && contractorID) {
            fetchContractorPayments(companyID, contractorID);
        }
    }, [checkStatus, companyID, contractorID, teamId]);

    return (
        <ContractorPaymentsList
            payments={contractorPayments}
            setPayments={setContractorPayments}
            isBusy={isBusy}
            teamId={teamId}
            companyID={companyID}
            title="Employee(Contractor) Payments"
        />
    );
}

export default ZealContractorPayroll;
